import { getByPath } from "../../../../dot-notation/index.js";
import { deepFreezeDescendants } from "../../utils/deepFreeze.js";
import { regenerateErrorsByField } from "../createErrorsApi/regenerateErrorsByField.js";
import { initializeFields } from "../createStore/createStore.initializeFields.js";
import { resetFieldInitialValues } from "./createCoreApi.resetFieldInitialValues.js";
import { updateFieldsAndValues } from "./createCoreApi.updateFieldsAndValues.js";
function createCoreApi(store, getFormApi, getLogger, getSubscribersApi, refreshFormStatus, applyMutations, applyTransforms, getPrivateFieldApi, errorsByField) {
  const { notifyFieldSubscribers, notifyFormSubscribers, notifyMetaSubscribers } = getSubscribersApi();
  const privateFieldApi = getPrivateFieldApi();
  const coreApi = {
    change: (fieldName, maybeLazyValue, operations) => {
      const log = getLogger();
      const formApi = getFormApi();
      const nextValue = typeof maybeLazyValue === "function" ? maybeLazyValue(
        getByPath(store.values, fieldName),
        store.values
      ) : maybeLazyValue;
      log("change", fieldName, nextValue);
      const initialChangedValues = {
        [fieldName]: nextValue
      };
      const changedValues = applyMutations(formApi, applyTransforms(formApi, initialChangedValues), fieldName);
      updateFieldsAndValues(store, changedValues, privateFieldApi);
      const arrayFieldOperations = operations ? { [fieldName]: operations } : void 0;
      notifyFieldSubscribers(
        Object.keys(changedValues),
        arrayFieldOperations
      );
      refreshFormStatus();
      notifyFormSubscribers();
    },
    batch: (maybeLazyFields) => {
      const log = getLogger();
      const formApi = getFormApi();
      const nextValues = typeof maybeLazyFields === "function" ? maybeLazyFields(store.values) : maybeLazyFields;
      log("batch", nextValues);
      if (nextValues?.constructor !== Object) {
        log("batch", "invalid input!");
        return;
      }
      const initialChangedValues = {
        ...nextValues
      };
      const changedValues = applyMutations(formApi, applyTransforms(formApi, initialChangedValues));
      updateFieldsAndValues(store, changedValues, privateFieldApi);
      notifyFieldSubscribers(Object.keys(changedValues));
      refreshFormStatus();
      notifyFormSubscribers();
    },
    // biome-ignore lint/style/useDefaultParameterLast:
    reset: (mode = "preserve", initialValues, silent) => {
      const log = getLogger();
      const formApi = getFormApi();
      log("reset", mode);
      if (mode === "force") {
        formApi.clearError();
      }
      resetFieldInitialValues(store, formApi, mode, initialValues);
      refreshFormStatus(silent);
      if (!silent) {
        notifyFieldSubscribers(Object.keys(store.fields));
        notifyMetaSubscribers();
        notifyFormSubscribers();
      }
    },
    initialize: (config) => {
      const log = getLogger();
      const formApi = getFormApi();
      const prevFields = formApi.getFields();
      const { initialValues, fields, errors, formStatus } = initializeFields({
        ...config,
        fields: { ...prevFields, ...config?.fields }
      });
      log("initialize", config);
      formApi.clearError();
      store.initialValues = initialValues;
      store.errors = errors;
      store.fields = fields;
      store.meta = { disabled: false, submitting: false, validating: false, status: formStatus };
      store.values = structuredClone(initialValues);
      regenerateErrorsByField(store, errorsByField);
      deepFreezeDescendants(store);
      notifyFieldSubscribers(Object.keys(store.fields));
      notifyMetaSubscribers();
      notifyFormSubscribers();
    }
  };
  return coreApi;
}
export {
  createCoreApi
};
//# sourceMappingURL=createCoreApi.js.map
